<template>
  <template v-if="multiple">
    <FloatLabel class="">
      <MultiSelect
        id="ms-cities"
        :options="options"
        :filter="filter"
        :class="sizeClass[size]"
        v-model="inputValue"
        fluid
        :maxSelectedLabels="3"
      />
      <label for="ms-cities">{{ label }}</label>
    </FloatLabel>
  </template>
  <template v-else>
    <template v-if="fixedLabel">
      <div class="fixed-label" :class="dirty && errorMessage ? 'error' : ''">
        <label for="ms-cities">{{ label }}</label>
        <Select
          id="ms-cities"
          v-model="inputValue"
          :options="options"
          :placeholder="inlineOption"
          :class="sizeClass[size]"
          :filter="filter"
          fluid
        />
        <small v-if="dirty && errorMessage" class="error-message">
        {{ errorMessage }}
      </small>
      </div>
    </template>
    <template v-else>
      <FloatLabel class="">
        <Select
          id="ms-cities"
          v-model="inputValue"
          :options="options"
          :class="sizeClass[size]"
          :filter="filter"
          fluid
        />
        <label for="ms-cities">{{ label }}</label>
      </FloatLabel>
    </template>

  </template>
</template>

<script setup>
import { computed } from 'vue';
import FloatLabel from 'primevue/floatlabel';
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';

const props = defineProps({
  label: String,
  multiple: { type: Boolean, required: false, default: false },
  filter: { type: Boolean, required: false },
  fixedLabel: { type: Boolean, required: false, default: false },
  options: Array,
  modelValue: [Array, String],
  size: { type: String, default: 'lg' },
  inlineOption: { type: String, default: '' },
  dirty: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
});

const sizeClass = { sm: 'small-select', md: 'medium-select', lg: 'large-select' };
const emit = defineEmits('update:modelValue');

const inputValue = computed({
  get: () => props.modelValue,
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped lang="scss">
.fixed-label {
  label {
    font-size: 18px;

    @media (min-width: 1281px) {
      font-size: 20px;
    }
  }
}

:deep(.p-select) {
  width: 100%;
  height: 50px;
  align-items: center;
  padding: 0 16px;
  border: 2px solid $AC_Offwhite;
  border-radius: 5px;
  background-color: #fafafa;
  font-size: clamp(18px, 24px, 1.5vw);

  @media (min-width: 1281px) {
    height: 60px;
  }

  .p-select-label {
    padding: 0;
    font-size: clamp(18px, 24px, 1.5vw);
    color: $AC_Black;
  }

  .p-select-dropdown {
    width: 16px;
    height: auto;
    color: #767676;
  }

  &:not(.p-disabled).p-focus,
  &:not(.p-disabled):hover {
    border-color: $AC_Orange;
  }
}

.error {
  :deep(.p-select) {
    border-color: $AC_Primary;
  }

  :deep(.error-message) {
    font-size: clamp(14px, 18px, 1.25vw);
    color: $AC_Primary;
  }
}

// Acura specific styles
.acura {
  .fixed-label {
    label,
    :deep(.p-select-label) {
      font-family: 'Avenir Book';
    }
  }
}
</style>
